/*
  Processes passed data based on JSON-API defaults into more manageable data.

  This should probably be refactored as a class.

  Processes passed data.
  Valid opts:
     - attr_includes: moves included object to the related objects.
     - merge_attrs: moves embedded objects to the parent element. This goes against
         the JSONAPI object structure, but reads cleaner.
     - recursive: allows running processing on child objects.
*/
const processSuccess = (resp, opts = {}) => {
  resp = resp || {}
  const body = resp.data || {}
  const data = body.data || {}
  const included = body.included || []

  let processed = _processData(data, opts)
  processed.included = included
  processed = _processIncludes(processed, opts)

  return processed
}

// Emits to parent for generic error handling.
// Otherwise, simply override this method
const processErrors = (resp) => {
  let err = resp.response.data.error
  const errs = resp.response.data.errors
  if (errs && errs.length) {
    err = resp.response.data.errors[0]
  } else if (errs && !errs.length) {
    err = ''
    Object.keys(errs).forEach((item) => {
      err += [item, errs[item]].join(' ')
    })
  }

  return err
}

/* Private methods */

const _processData = (data, opts = {}) => {
  let processed
  // We expect either an object or array to be returned.
  const isObject = _isObject(data)

  if (isObject) {
    processed = _processReturnedObject(data)

    if (opts.merge_attrs || opts.recursive) {
      processed = _processObj(processed, opts)
    }
  } else if (Array.isArray(data)) {
    processed = _processReturnedArray(data, opts)
  }

  return processed
}

const _processObj = (processed, opts = {}) => {
  for (let key of Object.keys(processed)) {
    if (processed[key] && _isObject(processed[key])) {
      if (processed[key].data) {
        processed[key] = _processData(processed[key].data, opts)
      }

      if (opts.merge_attrs && processed[key].attributes) {
        processed[key] = _processObj(processed[key].attributes, opts)
        delete processed[key].attributes
      }
    } else if (processed[key] && Array.isArray(processed[key])) {
      processed[key] = _processReturnedArray(processed[key], opts)
    }
  }

  return processed
}

const _processIncludes = (processed, opts = {}) => {
  if (!processed.included) {
    return processed
  }

  if (Array.isArray(processed)) {
    processed = processed.map((item) => {
      item.included = processed.included
      return _includesToRelationships(item, opts)
    })
  } else {
    processed = _includesToRelationships(processed, opts)
  }


  return processed
}

// JSON-API array processing.
const _processReturnedArray = (arr, opts = {}) => {
  let items = []

  for (let item of arr) {
    if (!item) { continue }

    if (_isObject(item)) {
      if (item.data) {
        item = _processData(item.data, opts)
      } else if (item.attributes) {
        item = _processData(item, opts)
      }

      items.push(item)
    } else {
      const processedItem = _processData(item, opts)
      items.push(processedItem)
    }
  }

  return items
}

// JSON-API object processing.
const _processReturnedObject = (obj) => {
  let attrs = obj.attributes || {}
  attrs.relationships = attrs.relationships || {}
  attrs.id = obj.id
  attrs.type = obj.type

  if (obj.relationships) {
    for (let k in obj.relationships) {
      if (obj.relationships[k].data) {
        attrs.relationships[k] = _processData(obj.relationships[k].data)
      }
    }
  }

  return attrs
}

const _isObject = (obj) => {
  return !Array.isArray(obj) && (typeof obj === 'object')
}

const _hasOne = (rel) => {
  return !Array.isArray(rel)
}

const _includesToRelationships = (processed, opts = {}) => {
  for (let rel in processed.relationships) {
    // skip if there are already relationship attributes.
    if (processed.relationships[rel].attributes) { continue }

    let relObjs = processed.relationships[rel]
    const relHasOne = _hasOne(relObjs)
    const relArr = relHasOne ? [ relObjs ] : relObjs

    let included = processed.included.filter(item => {
      return relArr.filter(obj => {
        return item.type === obj.type && item.id === obj.id
      }).length > 0
    })

    if (included.length) {
      let item = (relHasOne ? included[0] : included)

      if (opts.attr_includes) {
        processed[rel] = relHasOne ? _processReturnedObject(item) : _processReturnedArray(item)
      } else {
        processed.relationships[rel] = {
          data: item
        }
      }
    }
  }

  return processed
}

exports.processSuccess = processSuccess
exports.processErrors = processErrors



//////////////////
// WEBPACK FOOTER
// ./~/jsonapi-helper/index.js
// module id = 905
// module chunks = 0